import React, { Component } from "react";
import Lightbox from "react-image-lightbox";

import Aux from "../../../../hoc/Aux/Aux";
import "./Projekt.css";

import imageSection3_1 from "../../../../img/architektura/Rysunek5.jpg";
import imageSection3_2 from "../../../../img/architektura/Rysunek9.jpg";
import imageSection3_3 from "../../../../img/architektura/Rysunek7.jpg";
import imageSection3_4 from "../../../../img/architektura/Rysunek8.jpg";
import imageSection3_5 from "../../../../img/architektura/Rysunek6.jpg";

const images = [
  imageSection3_1,
  imageSection3_2,
  imageSection3_3,
  imageSection3_4,
  imageSection3_5
];

export default class Projekt extends Component {
  constructor(props) {
    super(props);

    this.state = {
      photoIndex: 0,
      isOpen: false,
      imagePadding: 100
    };
  }
  render() {
    const { photoIndex, isOpen } = this.state;

    return (
      <Aux>
        <div className="card-background row p-5">
          <div className="col-md lead mt-3">
            Jeżeli jest oczekiwanie:
            <ul>
              <li>wnętrze we własnym stylu</li>
              <li>pełen zakres projektu</li>
              <li>szczegółowe zestawienie materiałów</li>
              <li>poznanie kosztów inwestycji</li>
              <li>instalacje dedykowane</li>
              <li>unikanie kosztownych zmian</li>
            </ul>
          </div>
          <div className="col-md lead mt-3">
            Rozwiązaniem jest projekt:
            <ul>
              <li>rozwinięcie ustalonej wcześniej koncepcji</li>
              <li>widoki i wizualizacje ułatwiające wybór</li>
              <li>wymiary ścian, posadzek i sufitów</li>
              <li>jednoznaczne rysunki dla instalatorów</li>
              <li>rzut mebli kuchennych</li>
              <li>układ płytek i dekorów w łazience</li>
              <li>dokumentacja papierowa / 2 kopie / lub elektroniczna</li>
            </ul>
          </div>
          <div className="row pt-4 d-flex justify-content-center">
            <div className="image-lightbox col-lg-4">
              <img
                src={imageSection3_1}
                alt=""
                className="img-fluid m-2 p-1 border border-dark rounded"
                onClick={() => this.setState({ isOpen: true, photoIndex: 0 })}
              />
            </div>
            <div className="image-lightbox col-lg-4">
              <img
                src={imageSection3_2}
                alt=""
                className="img-fluid m-2 p-1 border border-dark rounded"
                onClick={() => this.setState({ isOpen: true, photoIndex: 1 })}
              />
            </div>
            <div className="image-lightbox col-lg-4">
              <img
                src={imageSection3_3}
                alt=""
                className="img-fluid m-2 p-1 border border-dark rounded"
                onClick={() => this.setState({ isOpen: true, photoIndex: 2 })}
              />
            </div>
            <div className="image-lightbox col-lg-4">
              <img
                src={imageSection3_4}
                alt=""
                className="img-fluid m-2 p-1 border border-dark rounded"
                onClick={() => this.setState({ isOpen: true, photoIndex: 3 })}
              />
            </div>
            <div className="image-lightbox col-lg-4">
              <img
                src={imageSection3_5}
                alt=""
                className="img-fluid m-2 p-1 border border-dark rounded"
                onClick={() => this.setState({ isOpen: true, photoIndex: 4 })}
              />
            </div>
          </div>
        </div>
        {isOpen && (
          <Lightbox
            mainSrc={images[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + images.length - 1) % images.length
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % images.length
              })
            }
          />
        )}
      </Aux>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Architecture/Services/Projekt/Projekt.js